import { DateTime } from "luxon";

// Note: the calendar works in the browser's clock, so a mine time goes in as the same wall-clock reading and comes back in the
// mine's zone, which is luxon's default zone.
export const toCalendar = (value: DateTime | null | undefined) =>
  value ? new Date(value.year, value.month - 1, value.day, value.hour, value.minute) : null;

export const fromCalendar = (date: Date, withTime: boolean) => DateTime.fromObject({
  year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate(),
  hour: withTime ? date.getHours() : 0, minute: withTime ? date.getMinutes() : 0,
});
